import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaArrowRight,
  FaQuoteLeft,
  FaGraduationCap,
  FaUniversity,
  FaUserTie,
  FaShieldAlt,
  FaBookOpen,
  FaStar,
  FaMapMarkerAlt,
} from "react-icons/fa";

import ceo from "./mrsamkargbo.jpg";
import principalImage from "./mrguwor.png";
import businessnamager from "./auntsatta.jpg";

const schoolLeadershipTeam = [
  {
    image: ceo,
    name: "Mr. Sam A. Kargbo",
    role: "Proprietor",
    description:
      "Provides strategic school leadership, oversees academic performance, guides staff and students, and promotes a disciplined, inclusive, and high-achieving learning environment.",
    email: "samkargbo@.edu",
    phone: "+231 XXX XXX XXX",
    number: "01",
    initials: "SK",
  },
  {
    image: principalImage,
    name: "Mr. Ben N. Guwor",
    role: "Principal",
    description:
      "Oversees daily academic operations, coordinates teaching and learning activities, supports teachers, monitors student progress, and helps maintain high educational standards throughout the school.",
    email: "benguwor@gmail.com",
    phone: "+231 XXX XXX XXX",
    number: "02",
    initials: "BG",
  },
  {
    image: businessnamager,
    name: "Mrs Satta King Leaman",
    role: "Business Manager",
    description:
      "Manages the school's financial and administrative operations, oversees budgeting and resource allocation, maintains financial records, and supports effective planning to ensure the school's sustainable growth and operational efficiency.",
    email: "sattaking@gmail.com",
    phone: "+231 XXX XXX XXX",
    number: "03",
    initials: "SL",
  },
];

const leadershipPillars = [
  {
    icon: <FaBookOpen />,
    title: "Academic Excellence",
    description:
      "Supporting effective teaching, learning, and student achievement.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Character & Discipline",
    description:
      "Promoting responsibility, respect, integrity, and positive conduct.",
  },
  {
    icon: <FaGraduationCap />,
    title: "Student Development",
    description:
      "Encouraging learners to build confidence, skills, and purpose.",
  },
];

const StaffPage = () => {
  return (
    <section className="zpa-staff">
      <style>{staffStyles}</style>

      {/* Brand heading */}
      <div className="zpa-staff-hero">
        <div className="zpa-staff-hero-pattern" />

        <div className="zpa-staff-container zpa-staff-hero-inner">
          <div className="zpa-staff-brand">
            <div className="zpa-staff-brand-icon">
              <FaUniversity />
            </div>

            <div>
              <strong>ZION PRAISE ACADEMY</strong>
              <span>SENIOR HIGH SCHOOL</span>
            </div>
          </div>

          <div className="zpa-staff-location">
            <FaMapMarkerAlt />
            <span>Monrovia, Liberia</span>
          </div>

          <div className="zpa-staff-hero-copy">
            <div className="zpa-staff-eyebrow">
              <span />
              OUR SCHOOL COMMUNITY
            </div>

            <h1>
              Leadership that
              <br />
              <span>inspires excellence.</span>
            </h1>

            <p>
              Meet the dedicated school leaders committed to academic growth,
              student welfare, positive values, and a strong educational
              community.
            </p>

            <div className="zpa-staff-hero-meta">
              <span>
                <FaCheckIcon />
                Student-centered leadership
              </span>
              <span>
                <FaCheckIcon />
                A commitment to learning
              </span>
            </div>
          </div>

          <div className="zpa-staff-hero-emblem">
            <div className="zpa-staff-emblem-ring">
              <FaGraduationCap />
            </div>
            <span>LEARN</span>
            <span>LEAD</span>
            <span>INSPIRE</span>
          </div>
        </div>

        <div className="zpa-staff-hero-bottom">
          <div className="zpa-staff-container zpa-staff-hero-bottom-inner">
            <span>OUR LEADERSHIP TEAM</span>
            <span className="zpa-staff-bottom-rule" />
            <span>EDUCATION · CHARACTER · PURPOSE</span>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="zpa-staff-intro">
        <div className="zpa-staff-container">
          <div className="zpa-staff-intro-grid">
            <div>
              <div className="zpa-staff-section-label">
                <span />
                MEET OUR LEADERS
              </div>

              <h2>
                The people behind
                <br />
                <span>our shared vision.</span>
              </h2>
            </div>

            <div className="zpa-staff-intro-text">
              <p>
                Strong schools are built through purposeful leadership,
                collaboration, and a commitment to every learner. Our
                leadership team works to support a positive school culture
                and an environment where students and educators can grow.
              </p>

              <div className="zpa-staff-intro-accent">
                <FaQuoteLeft />
                <span>
                  Building character. Inspiring excellence. Shaping the future.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Leadership cards */}
      <div className="zpa-staff-leadership">
        <div className="zpa-staff-container">
          <div className="zpa-staff-grid-heading">
            <div>
              <span className="zpa-staff-overline">SCHOOL ADMINISTRATION</span>
              <h2>Meet our leadership</h2>
            </div>

            <div className="zpa-staff-count">
              <span>{String(schoolLeadershipTeam.length).padStart(2, "0")}</span>
              <small>LEADERS</small>
            </div>
          </div>

          <div className="zpa-staff-grid">
            {schoolLeadershipTeam.map((leader) => (
              <article className="zpa-staff-card" key={leader.email}>
                <div className="zpa-staff-card-top">
                  <span className="zpa-staff-card-number">
                    {leader.number}
                  </span>

                  <span className="zpa-staff-card-star">
                    <FaStar />
                  </span>
                </div>

                <div className="zpa-staff-photo-area">
                  <div className="zpa-staff-photo-frame">
                    <img
                      src={leader.image}
                      alt={`${leader.name}, ${leader.role} at Zion Praise Academy`}
                      className="zpa-staff-photo"
                      loading="lazy"
                    />
                  </div>

                  <div className="zpa-staff-photo-decoration" />

                  <div className="zpa-staff-role">
                    <span className="zpa-staff-role-dot" />
                    {leader.role}
                  </div>
                </div>

                <div className="zpa-staff-card-body">
                  <span className="zpa-staff-card-kicker">
                    SCHOOL LEADERSHIP
                  </span>

                  <h3>{leader.name}</h3>

                  <div className="zpa-staff-name-rule" />

                  <p className="zpa-staff-card-description">
                    {leader.description}
                  </p>

                  <div className="zpa-staff-card-contact">
                    <a
                      href={`mailto:${leader.email}`}
                      aria-label={`Email ${leader.name}`}
                      title={`Email ${leader.name}`}
                    >
                      <FaEnvelope />
                      <span>Email</span>
                    </a>

                    <a
                      href={`tel:${leader.phone.replace(/[^\d+]/g, "")}`}
                      aria-label={`Call ${leader.name}`}
                      title={`Call ${leader.name}`}
                    >
                      <FaPhoneAlt />
                      <span>Call</span>
                    </a>
                  </div>

                  <div className="zpa-staff-card-bottom">
                    <span>ADMINISTRATION</span>
                    <FaArrowRight />
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="zpa-staff-disclaimer">
            <span className="zpa-staff-disclaimer-icon">
              <FaShieldAlt />
            </span>
            <p>
              Our leadership team is committed to fostering a respectful,
              supportive, and academically focused school environment.
            </p>
          </div>
        </div>
      </div>

      {/* Leadership priorities */}
      <div className="zpa-staff-pillars">
        <div className="zpa-staff-container">
          <div className="zpa-staff-pillars-heading">
            <div className="zpa-staff-section-label">
              <span />
              WHAT GUIDES US
            </div>

            <h2>
              Leadership with
              <span> purpose.</span>
            </h2>

            <p>
              Our priorities reflect the kind of school community we strive to
              build every day.
            </p>
          </div>

          <div className="zpa-staff-pillars-grid">
            {leadershipPillars.map((pillar, index) => (
              <article className="zpa-staff-pillar" key={pillar.title}>
                <div className="zpa-staff-pillar-top">
                  <span>0{index + 1}</span>
                  <div className="zpa-staff-pillar-icon">{pillar.icon}</div>
                </div>

                <h3>{pillar.title}</h3>
                <p>{pillar.description}</p>

                <div className="zpa-staff-pillar-line" />
              </article>
            ))}
          </div>
        </div>
      </div>

      {/* Closing brand banner */}
      <div className="zpa-staff-closing">
        <div className="zpa-staff-container">
          <div className="zpa-staff-closing-panel">
            <div className="zpa-staff-closing-icon">
              <FaGraduationCap />
            </div>

            <div className="zpa-staff-closing-copy">
              <span>ZION PRAISE ACADEMY SENIOR HIGH SCHOOL</span>
              <h2>One school. One vision. A brighter future.</h2>
              <p>
                Committed to learning, character, and the potential of every
                student.
              </p>
            </div>

            <div className="zpa-staff-closing-mark">
              <FaStar />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="zpa-staff-footer">
        <div className="zpa-staff-container zpa-staff-footer-inner">
          <div className="zpa-staff-footer-brand">
            <span className="zpa-staff-footer-icon">
              <FaUniversity />
            </span>

            <div>
              <strong>ZION PRAISE ACADEMY</strong>
              <span>SENIOR HIGH SCHOOL</span>
            </div>
          </div>

          <div className="zpa-staff-footer-motto">
            <span>LEARNING · CHARACTER · PURPOSE</span>
            <small>Monrovia, Liberia</small>
          </div>

          <button
            className="zpa-staff-back-top"
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Back to top <FaArrowRight />
          </button>
        </div>

        <div className="zpa-staff-footer-base">
          <div className="zpa-staff-container zpa-staff-footer-base-inner">
            <span>
              © {new Date().getFullYear()} Zion Praise Academy Senior High
              School.
            </span>
            <span>Building a brighter future through education.</span>
          </div>
        </div>
      </footer>
    </section>
  );
};

const FaCheckIcon = () => (
  <span className="zpa-staff-check" aria-hidden="true">
    ✓
  </span>
);

const staffStyles = `
  .zpa-staff {
    --zpa-black: #171717;
    --zpa-black-light: #242424;
    --zpa-gold: #D5AA3F;
    --zpa-gold-light: #F0D78D;
    --zpa-gold-dark: #87671D;
    --zpa-white: #FFFFFF;
    --zpa-paper: #F7F6F2;
    --zpa-gray: #6D6D6D;
    --zpa-border: #E8E4D9;
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #FFFFFF;
    color: var(--zpa-black);
    font-family: Inter, "Segoe UI", Arial, sans-serif;
    line-height: 1.6;
  }

  .zpa-staff *,
  .zpa-staff *::before,
  .zpa-staff *::after {
    box-sizing: border-box;
  }

  .zpa-staff button,
  .zpa-staff a {
    font-family: inherit;
  }

  .zpa-staff a {
    text-decoration: none;
  }

  .zpa-staff-container {
    width: min(1200px, calc(100% - 64px));
    margin: 0 auto;
  }

  /* HERO */
  .zpa-staff-hero {
    position: relative;
    overflow: hidden;
    background: #171717;
    color: #FFFFFF;
  }

  .zpa-staff-hero-pattern {
    position: absolute;
    top: -220px;
    right: -130px;
    width: 660px;
    height: 660px;
    border: 1px solid rgba(213,170,63,.19);
    border-radius: 50%;
    pointer-events: none;
  }

  .zpa-staff-hero-pattern::before,
  .zpa-staff-hero-pattern::after {
    content: "";
    position: absolute;
    border: 1px solid rgba(213,170,63,.13);
    border-radius: 50%;
  }

  .zpa-staff-hero-pattern::before {
    inset: 50px;
  }

  .zpa-staff-hero-pattern::after {
    inset: 105px;
  }

  .zpa-staff-hero-inner {
    min-height: 420px;
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 220px;
    align-items: center;
    gap: 50px;
    padding-top: 34px;
    padding-bottom: 65px;
  }

  .zpa-staff-brand {
    position: absolute;
    top: 28px;
    left: 0;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .zpa-staff-brand-icon {
    width: 43px;
    height: 43px;
    display: grid;
    place-items: center;
    background: var(--zpa-gold);
    color: #171717;
    font-size: 20px;
  }

  .zpa-staff-brand strong,
  .zpa-staff-brand span {
    display: block;
  }

  .zpa-staff-brand strong {
    font-size: 12px;
    font-weight: 850;
    letter-spacing: 1.3px;
  }

  .zpa-staff-brand div > span {
    margin-top: 3px;
    color: #D6D0C0;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 2px;
  }

  .zpa-staff-location {
    position: absolute;
    top: 40px;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #D6D2C7;
    font-size: 11px;
  }

  .zpa-staff-location svg {
    color: var(--zpa-gold-light);
  }

  .zpa-staff-hero-copy {
    grid-column: 1;
    margin-top: 76px;
    animation: zpa-staff-enter .6s ease both;
  }

  .zpa-staff-eyebrow {
    display: flex;
    align-items: center;
    gap: 11px;
    margin-bottom: 18px;
    color: var(--zpa-gold-light);
    font-size: 9px;
    font-weight: 850;
    letter-spacing: 2.1px;
  }

  .zpa-staff-eyebrow > span:first-child {
    width: 26px;
    height: 2px;
    background: var(--zpa-gold);
  }

  .zpa-staff-hero-copy h1 {
    margin: 0;
    color: #FFFFFF;
    font-size: clamp(39px, 5.2vw, 62px);
    font-weight: 850;
    line-height: 1.1;
    letter-spacing: -2px;
  }

  .zpa-staff-hero-copy h1 span {
    color: var(--zpa-gold-light);
  }

  .zpa-staff-hero-copy > p {
    max-width: 640px;
    margin: 21px 0 0;
    color: #D0CEC8;
    font-size: 13px;
    line-height: 2;
  }

  .zpa-staff-hero-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 25px;
    margin-top: 24px;
  }

  .zpa-staff-hero-meta > span {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    color: #E4E1D9;
    font-size: 10px;
    font-weight: 650;
  }

  .zpa-staff-check {
    color: var(--zpa-gold-light);
    font-size: 15px;
    font-weight: 900;
  }

  .zpa-staff-hero-emblem {
    width: 205px;
    height: 240px;
    grid-column: 2;
    grid-row: 1;
    align-self: end;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 76px;
    border: 1px solid rgba(213,170,63,.37);
    background: rgba(255,255,255,.025);
    color: #F1E3BB;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 3px;
  }

  .zpa-staff-emblem-ring {
    width: 95px;
    height: 95px;
    display: grid;
    place-items: center;
    margin-bottom: 16px;
    border: 1px solid var(--zpa-gold);
    border-radius: 50%;
    color: var(--zpa-gold-light);
    font-size: 41px;
  }

  .zpa-staff-hero-emblem > span + span {
    margin-top: 5px;
  }

  .zpa-staff-hero-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    border-top: 1px solid rgba(255,255,255,.15);
  }

  .zpa-staff-hero-bottom-inner {
    min-height: 48px;
    display: flex;
    align-items: center;
    gap: 20px;
    color: #CFCBC0;
    font-size: 9px;
    font-weight: 750;
    letter-spacing: 1.6px;
  }

  .zpa-staff-bottom-rule {
    width: 40px;
    height: 1px;
    background: var(--zpa-gold);
  }

  .zpa-staff-hero-bottom-inner > span:last-child {
    margin-left: auto;
  }

  /* INTRODUCTION */
  .zpa-staff-intro {
    padding: 76px 0 69px;
    background: #FFFFFF;
  }

  .zpa-staff-intro-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 70px;
  }

  .zpa-staff-section-label {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    color: #85661D;
    font-size: 9px;
    font-weight: 850;
    letter-spacing: 2px;
  }

  .zpa-staff-section-label > span {
    width: 25px;
    height: 2px;
    background: var(--zpa-gold);
  }

  .zpa-staff-intro h2,
  .zpa-staff-pillars-heading h2 {
    margin: 0;
    color: #1A1A1A;
    font-size: clamp(31px, 3.5vw, 42px);
    font-weight: 850;
    letter-spacing: -1.5px;
    line-height: 1.22;
  }

  .zpa-staff-intro h2 > span {
    color: #A17B23;
  }

  .zpa-staff-intro-text > p {
    margin: 0;
    color: #6D6D6D;
    font-size: 13px;
    line-height: 2;
  }

  .zpa-staff-intro-accent {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 21px;
    padding-top: 18px;
    border-top: 1px solid #E9E5DA;
    color: #343434;
    font-size: 11px;
    font-weight: 750;
  }

  .zpa-staff-intro-accent svg {
    flex: 0 0 auto;
    color: #B58B29;
    font-size: 18px;
  }

  /* LEADERSHIP CARDS */
  .zpa-staff-leadership {
    padding: 73px 0 82px;
    background: #F7F6F2;
    border-top: 1px solid #EEEAE0;
    border-bottom: 1px solid #EAE6DB;
  }

  .zpa-staff-grid-heading {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 25px;
    margin-bottom: 34px;
  }

  .zpa-staff-overline {
    color: #927126;
    font-size: 9px;
    font-weight: 850;
    letter-spacing: 2px;
  }

  .zpa-staff-grid-heading h2 {
    margin: 8px 0 0;
    color: #191919;
    font-size: clamp(28px, 3vw, 37px);
    font-weight: 850;
    letter-spacing: -1px;
    line-height: 1.25;
  }

  .zpa-staff-count {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #FFFFFF;
    border: 1px solid #E6E0D0;
  }

  .zpa-staff-count > span {
    color: #98741F;
    font-size: 22px;
    font-weight: 850;
  }

  .zpa-staff-count small {
    color: #6B6B6B;
    font-size: 8px;
    font-weight: 850;
    letter-spacing: 1.5px;
  }

  .zpa-staff-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
    gap: 23px;
  }

  .zpa-staff-card {
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #FFFFFF;
    border: 1px solid #E7E2D7;
    box-shadow: 0 5px 19px rgba(27,25,19,.035);
    transition: transform .24s ease, box-shadow .24s ease, border-color .24s ease;
  }

  .zpa-staff-card:hover {
    transform: translateY(-5px);
    border-color: #D8C58F;
    box-shadow: 0 17px 35px rgba(27,25,19,.09);
  }

  .zpa-staff-card-top {
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #F0EDE6;
  }

  .zpa-staff-card-number {
    color: #A07A21;
    font-size: 11px;
    font-weight: 850;
    letter-spacing: 1.4px;
  }

  .zpa-staff-card-star {
    color: #C6A34D;
    font-size: 11px;
  }

  .zpa-staff-photo-area {
    position: relative;
    padding: 21px 21px 0;
    background: #FFFFFF;
  }

  .zpa-staff-photo-frame {
    position: relative;
    z-index: 1;
    height: 235px;
    overflow: hidden;
    background: #EAE5D9;
  }

  .zpa-staff-photo {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center 25%;
    transition: transform .4s ease;
  }

  .zpa-staff-card:hover .zpa-staff-photo {
    transform: scale(1.035);
  }

  .zpa-staff-photo-decoration {
    position: absolute;
    right: 14px;
    bottom: -8px;
    width: 60px;
    height: 60px;
    border-right: 5px solid var(--zpa-gold);
    border-bottom: 5px solid var(--zpa-gold);
    pointer-events: none;
  }

  .zpa-staff-role {
    position: relative;
    z-index: 2;
    width: fit-content;
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: -17px 0 0 11px;
    padding: 9px 13px;
    background: #191919;
    color: #FFFFFF;
    border-bottom: 2px solid var(--zpa-gold);
    font-size: 10px;
    font-weight: 750;
  }

  .zpa-staff-role-dot {
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
    background: var(--zpa-gold-light);
  }

  .zpa-staff-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 22px 22px 0;
  }

  .zpa-staff-card-kicker {
    color: #A27D25;
    font-size: 8px;
    font-weight: 850;
    letter-spacing: 1.8px;
  }

  .zpa-staff-card-body h3 {
    margin: 9px 0 0;
    color: #1C1C1C;
    font-size: clamp(17px, 1.5vw, 20px);
    font-weight: 850;
    line-height: 1.4;
    letter-spacing: -.35px;
    overflow-wrap: anywhere;
  }

  .zpa-staff-name-rule {
    width: 37px;
    height: 3px;
    margin-top: 13px;
    background: var(--zpa-gold);
  }

  .zpa-staff-card-description {
    flex: 1;
    margin: 16px 0 23px;
    color: #707070;
    font-size: 12px;
    line-height: 1.95;
  }

  .zpa-staff-card-contact {
    display: flex;
    gap: 10px;
    padding: 16px 0;
    border-top: 1px solid #ECE8DF;
  }

  .zpa-staff-card-contact a {
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 12px;
    border: 1px solid #E7E1D3;
    background: #FBFAF7;
    color: #2D2D2D;
    font-size: 10px;
    font-weight: 750;
    transition: background .2s ease, border-color .2s ease;
  }

  .zpa-staff-card-contact a:hover {
    border-color: #D5AA3F;
    background: #F5E9C7;
  }

  .zpa-staff-card-contact a svg {
    color: #99741F;
    font-size: 11px;
  }

  .zpa-staff-card-bottom {
    min-height: 43px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 -22px;
    padding: 0 22px;
    background: #191919;
    color: #D9D5CB;
  }

  .zpa-staff-card-bottom > span {
    font-size: 8px;
    font-weight: 800;
    letter-spacing: 1.7px;
  }

  .zpa-staff-card-bottom svg {
    color: var(--zpa-gold-light);
    font-size: 11px;
    transition: transform .2s ease;
  }

  .zpa-staff-card:hover .zpa-staff-card-bottom svg {
    transform: translateX(4px);
  }

  .zpa-staff-disclaimer {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 28px;
    padding: 18px 20px;
    background: #FFFFFF;
    border: 1px solid #E7E1D4;
  }

  .zpa-staff-disclaimer-icon {
    width: 37px;
    height: 37px;
    flex: 0 0 37px;
    display: grid;
    place-items: center;
    background: #F5E9C7;
    color: #6D531A;
    font-size: 16px;
  }

  .zpa-staff-disclaimer p {
    margin: 0;
    color: #66635B;
    font-size: 11px;
    line-height: 1.8;
  }

  /* SCHOOL PRIORITIES */
  .zpa-staff-pillars {
    padding: 82px 0 89px;
    background: #FFFFFF;
  }

  .zpa-staff-pillars-heading {
    max-width: 720px;
    margin: 0 auto 38px;
    text-align: center;
  }

  .zpa-staff-pillars-heading .zpa-staff-section-label {
    justify-content: center;
  }

  .zpa-staff-pillars-heading h2 {
    font-size: clamp(30px, 3.5vw, 42px);
  }

  .zpa-staff-pillars-heading h2 span {
    color: #A17B23;
  }

  .zpa-staff-pillars-heading > p {
    margin: 15px 0 0;
    color: #727272;
    font-size: 12px;
    line-height: 1.9;
  }

  .zpa-staff-pillars-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 19px;
  }

  .zpa-staff-pillar {
    padding: 25px 24px 22px;
    background: #F8F7F3;
    border: 1px solid #EBE6DA;
    transition: border-color .2s ease, transform .2s ease;
  }

  .zpa-staff-pillar:hover {
    transform: translateY(-3px);
    border-color: #D7C38B;
  }

  .zpa-staff-pillar-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .zpa-staff-pillar-top > span {
    color: #A17B23;
    font-size: 11px;
    font-weight: 850;
    letter-spacing: 1.3px;
  }

  .zpa-staff-pillar-icon {
    width: 46px;
    height: 46px;
    display: grid;
    place-items: center;
    background: #F0E2B9;
    color: #654C16;
    font-size: 20px;
  }

  .zpa-staff-pillar h3 {
    margin: 22px 0 9px;
    color: #222222;
    font-size: 16px;
    font-weight: 850;
    line-height: 1.45;
  }

  .zpa-staff-pillar p {
    min-height: 45px;
    margin: 0;
    color: #717171;
    font-size: 11px;
    line-height: 1.9;
  }

  .zpa-staff-pillar-line {
    width: 38px;
    height: 3px;
    margin-top: 21px;
    background: var(--zpa-gold);
  }

  /* CLOSING */
  .zpa-staff-closing {
    padding: 0 0 76px;
    background: #FFFFFF;
  }

  .zpa-staff-closing-panel {
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: 65px minmax(0, 1fr) 42px;
    align-items: center;
    gap: 23px;
    padding: 34px 35px;
    background: #EEDBA0;
    border: 1px solid #E1CA7D;
  }

  .zpa-staff-closing-icon {
    width: 63px;
    height: 63px;
    display: grid;
    place-items: center;
    background: #191919;
    color: var(--zpa-gold-light);
    font-size: 28px;
  }

  .zpa-staff-closing-copy > span {
    display: block;
    margin-bottom: 8px;
    color: #70561A;
    font-size: 8px;
    font-weight: 850;
    letter-spacing: 1.7px;
  }

  .zpa-staff-closing-copy h2 {
    margin: 0;
    color: #1B1B1B;
    font-size: clamp(20px, 2.7vw, 30px);
    font-weight: 850;
    letter-spacing: -.8px;
    line-height: 1.35;
  }

  .zpa-staff-closing-copy p {
    margin: 8px 0 0;
    color: #5F5439;
    font-size: 11px;
    line-height: 1.8;
  }

  .zpa-staff-closing-mark {
    display: grid;
    place-items: center;
    color: #97721E;
    font-size: 30px;
  }

  /* FOOTER */
  .zpa-staff-footer {
    background: #171717;
    color: #FFFFFF;
  }

  .zpa-staff-footer-inner {
    min-height: 118px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 25px;
    padding-top: 23px;
    padding-bottom: 23px;
  }

  .zpa-staff-footer-brand {
    display: flex;
    align-items: center;
    gap: 13px;
  }

  .zpa-staff-footer-icon {
    width: 43px;
    height: 43px;
    flex: 0 0 43px;
    display: grid;
    place-items: center;
    background: var(--zpa-gold);
    color: #171717;
    font-size: 20px;
  }

  .zpa-staff-footer-brand strong,
  .zpa-staff-footer-brand div > span {
    display: block;
  }

  .zpa-staff-footer-brand strong {
    font-size: 11px;
    font-weight: 850;
    letter-spacing: 1px;
  }

  .zpa-staff-footer-brand div > span {
    margin-top: 4px;
    color: var(--zpa-gold-light);
    font-size: 8px;
    font-weight: 750;
    letter-spacing: 1.7px;
  }

  .zpa-staff-footer-motto {
    text-align: center;
  }

  .zpa-staff-footer-motto span,
  .zpa-staff-footer-motto small {
    display: block;
  }

  .zpa-staff-footer-motto span {
    color: #E8D8A8;
    font-size: 8px;
    font-weight: 800;
    letter-spacing: 1.5px;
  }

  .zpa-staff-footer-motto small {
    margin-top: 6px;
    color: #BDBAB2;
    font-size: 10px;
  }

  .zpa-staff-back-top {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0 10px 10px;
    border: 0;
    background: transparent;
    color: #FFFFFF;
    font-size: 10px;
    font-weight: 750;
    cursor: pointer;
  }

  .zpa-staff-back-top svg {
    color: var(--zpa-gold-light);
    transform: rotate(-45deg);
  }

  .zpa-staff-footer-base {
    border-top: 1px solid rgba(255,255,255,.12);
  }

  .zpa-staff-footer-base-inner {
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    color: #AAA79F;
    font-size: 9px;
  }

  @keyframes zpa-staff-enter {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (min-width: 1450px) {
    .zpa-staff-hero-inner {
      min-height: 455px;
    }

    .zpa-staff-photo-frame {
      height: 260px;
    }
  }

  @media (max-width: 1000px) {
    .zpa-staff-container {
      width: calc(100% - 48px);
    }

    .zpa-staff-hero-inner {
      grid-template-columns: minmax(0, 1fr) 165px;
      gap: 30px;
    }

    .zpa-staff-hero-emblem {
      width: 165px;
      height: 210px;
    }

    .zpa-staff-emblem-ring {
      width: 78px;
      height: 78px;
      font-size: 33px;
    }

    .zpa-staff-intro-grid {
      gap: 40px;
    }

    .zpa-staff-grid {
      gap: 16px;
    }

    .zpa-staff-photo-area {
      padding-right: 15px;
      padding-left: 15px;
    }

    .zpa-staff-photo-frame {
      height: 210px;
    }

    .zpa-staff-card-body {
      padding-right: 16px;
      padding-left: 16px;
    }

    .zpa-staff-card-bottom {
      margin-right: -16px;
      margin-left: -16px;
      padding-right: 16px;
      padding-left: 16px;
    }

    .zpa-staff-card-contact {
      gap: 7px;
    }

    .zpa-staff-card-contact a {
      padding: 8px 10px;
    }
  }

  @media (max-width: 760px) {
    .zpa-staff-container {
      width: calc(100% - 38px);
    }

    .zpa-staff-hero-inner {
      min-height: auto;
      grid-template-columns: 1fr;
      gap: 0;
      padding-top: 100px;
      padding-bottom: 83px;
    }

    .zpa-staff-brand {
      top: 23px;
    }

    .zpa-staff-location {
      top: 37px;
      font-size: 10px;
    }

    .zpa-staff-hero-copy {
      grid-column: 1;
      grid-row: 1;
      margin-top: 17px;
    }

    .zpa-staff-hero-copy h1 {
      font-size: clamp(37px, 7vw, 54px);
    }

    .zpa-staff-hero-copy > p {
      max-width: 570px;
    }

    .zpa-staff-hero-emblem {
      display: none;
    }

    .zpa-staff-hero-bottom-inner {
      min-height: 44px;
      font-size: 8px;
      letter-spacing: 1px;
    }

    .zpa-staff-intro {
      padding: 60px 0;
    }

    .zpa-staff-intro-grid {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .zpa-staff-intro h2 {
      font-size: 36px;
    }

    .zpa-staff-leadership {
      padding: 60px 0 65px;
    }

    .zpa-staff-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 17px;
    }

    .zpa-staff-photo-frame {
      height: 225px;
    }

    .zpa-staff-card-body h3 {
      font-size: 17px;
    }

    .zpa-staff-card-contact {
      flex-wrap: wrap;
    }

    .zpa-staff-pillars {
      padding: 65px 0;
    }

    .zpa-staff-pillars-grid {
      grid-template-columns: 1fr;
      gap: 13px;
    }

    .zpa-staff-pillar {
      padding: 22px;
    }

    .zpa-staff-pillar p {
      min-height: 0;
    }

    .zpa-staff-closing {
      padding-bottom: 55px;
    }

    .zpa-staff-closing-panel {
      grid-template-columns: 55px minmax(0, 1fr);
      gap: 18px;
      padding: 25px;
    }

    .zpa-staff-closing-icon {
      width: 53px;
      height: 53px;
      font-size: 24px;
    }

    .zpa-staff-closing-mark {
      display: none;
    }

    .zpa-staff-footer-inner {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 520px) {
    .zpa-staff-container {
      width: calc(100% - 32px);
    }

    .zpa-staff-brand {
      gap: 9px;
    }

    .zpa-staff-brand-icon {
      width: 37px;
      height: 37px;
      font-size: 17px;
    }

    .zpa-staff-brand strong {
      font-size: 10px;
      letter-spacing: .8px;
    }

    .zpa-staff-brand div > span {
      font-size: 7px;
      letter-spacing: 1.4px;
    }

    .zpa-staff-location {
      top: 37px;
      font-size: 9px;
    }

    .zpa-staff-hero-inner {
      padding-top: 92px;
      padding-bottom: 78px;
    }

    .zpa-staff-hero-copy h1 {
      font-size: clamp(34px, 9vw, 43px);
      letter-spacing: -1.4px;
    }

    .zpa-staff-hero-copy > p {
      font-size: 12px;
      line-height: 1.9;
    }

    .zpa-staff-hero-meta {
      flex-direction: column;
      gap: 10px;
    }

    .zpa-staff-hero-bottom-inner {
      gap: 9px;
      font-size: 7px;
      letter-spacing: .7px;
    }

    .zpa-staff-bottom-rule {
      width: 18px;
      flex: 0 0 18px;
    }

    .zpa-staff-intro {
      padding: 48px 0;
    }

    .zpa-staff-intro h2 {
      font-size: 32px;
      letter-spacing: -1px;
    }

    .zpa-staff-intro-text > p {
      font-size: 12px;
    }

    .zpa-staff-intro-accent {
      align-items: flex-start;
      font-size: 10px;
      line-height: 1.8;
    }

    .zpa-staff-leadership {
      padding: 49px 0 52px;
    }

    .zpa-staff-grid-heading {
      align-items: center;
      margin-bottom: 24px;
    }

    .zpa-staff-grid-heading h2 {
      font-size: 25px;
    }

    .zpa-staff-overline {
      font-size: 8px;
      letter-spacing: 1.3px;
    }

    .zpa-staff-count {
      gap: 6px;
      padding: 8px;
    }

    .zpa-staff-count > span {
      font-size: 18px;
    }

    .zpa-staff-count small {
      font-size: 7px;
    }

    .zpa-staff-grid {
      grid-template-columns: 1fr;
      gap: 22px;
    }

    .zpa-staff-photo-area {
      padding: 16px 16px 0;
    }

    .zpa-staff-photo-frame {
      height: 300px;
    }

    .zpa-staff-card-body {
      padding: 20px 18px 0;
    }

    .zpa-staff-card-body h3 {
      font-size: 19px;
    }

    .zpa-staff-card-description {
      font-size: 12px;
    }

    .zpa-staff-card-bottom {
      margin-right: -18px;
      margin-left: -18px;
      padding-right: 18px;
      padding-left: 18px;
    }

    .zpa-staff-disclaimer {
      align-items: flex-start;
      padding: 14px;
    }

    .zpa-staff-pillars {
      padding: 51px 0;
    }

    .zpa-staff-pillars-heading h2 {
      font-size: 31px;
    }

    .zpa-staff-pillars-heading > p {
      font-size: 11px;
    }

    .zpa-staff-closing {
      padding-bottom: 40px;
    }

    .zpa-staff-closing-panel {
      grid-template-columns: 1fr;
      padding: 22px 19px;
    }

    .zpa-staff-closing-copy h2 {
      font-size: 24px;
    }

    .zpa-staff-closing-copy > span {
      font-size: 8px;
      line-height: 1.8;
    }

    .zpa-staff-footer-inner {
      align-items: flex-start;
      flex-direction: column;
      gap: 22px;
      padding-top: 25px;
      padding-bottom: 25px;
    }

    .zpa-staff-footer-motto {
      text-align: left;
    }

    .zpa-staff-footer-base-inner {
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
      gap: 6px;
      padding-top: 12px;
      padding-bottom: 12px;
      font-size: 9px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .zpa-staff *,
    .zpa-staff *::before,
    .zpa-staff *::after {
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      scroll-behavior: auto !important;
      transition-duration: .01ms !important;
    }
  }
`;

export default StaffPage;
